<template>
    <article class="tabs-component" >

        <nav class="nav nav-tabs nav-justified px-3" :id="((navId) ? navId : 'timeseries-card-tabs')" role="tablist">
            <a
                v-for="(tab, index) in tabs" :key="index"
                role="tab"
                class="nav-item nav-link"
                :class="{active : (index === indexOfOpenTab)}"
                @click="onTabNavClick(index, $event)" >
                {{ tab.getLabel() }}
            </a>
        </nav>

        <section class="tab-content p-4" :id="((tabsId) ? tabsId : 'timerseries-card-tabs-content')">
            <loading-spinner :loading="dataLoading"></loading-spinner>
            <slot />
            <!-- Can't pass anything through props, since tabs are slotted from outside -->
        </section>

    </article>
</template>

<script>
import LoadingSpinner from './LoadingSpinner';

export default {
    components : {"loading-spinner": LoadingSpinner},

    props : {

        navId : {
            type : String,
            default : "",
        },

        tabsId : {
            type : String,
            default : "",
        },

        dataLoading : {
            type : Boolean,
            default : false,
        }

    },

    data() {
        return {
            indexOfOpenTab : 0,
            tabs : [],
        };
    },

    watch : {

        dataLoading(newVal) {
            ((!newVal) ? this.initTabs() : this.resetTabs());
        }

    },

    mounted() {
        // Non-filtered children have loading spinner component as first child
        this.tabs = this.$children.filter((item) => { return item.isTab; });

        if (!this.dataLoading){ this.initTabs(); }
    },

    methods: {

        onTabNavClick(tabIdx, evt) {
            // prevent bootstrap setting anchor value to url (ie http://url.com/page#my-tab-id)
            evt.preventDefault();
            this.switchTab(tabIdx);
        },

        initTabs() {
            if (this.tabs.length > 0) this.tabs[0].activate();
            this.indexOfOpenTab = 0;
        },

        resetTabs() {
            if (this.tabs.length > 0) this.tabs[this.indexOfOpenTab].deactivate();
            this.indexOfOpenTab = 0;
        },

        switchTab(tabIdx) {
            this.tabs[this.indexOfOpenTab].deactivate();
            this.tabs[tabIdx].activate();
            this.indexOfOpenTab = tabIdx;
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/BootstrapTabs.vue